import { render } from "./AppVideoPlayer.vue?vue&type=template&id=0d911a30&ts=true"
import script from "./AppVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./AppVideoPlayer.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__